(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["promotion-popup"]) return;
  try {
    
    class PromotionPopup extends HTMLElement {
      connectedCallback() {
        this.dismissKey = 'promo-popup-dismissed';
        this.sessionKey = 'promo-popup-shown-session';

        if (localStorage.getItem(this.dismissKey) === '1') return;
        if (this.dataset.oncePerSession === 'true' && sessionStorage.getItem(this.sessionKey) === '1') return;

        this.shown = false;
        this.setupTrigger();
        this.setupActions();
      }

      setupTrigger() {
        const trigger = this.dataset.trigger;

        if (trigger === 'immediate') {
          setTimeout(() => this.show(), 300);
        } else if (trigger === 'delay') {
          const seconds = parseInt(this.dataset.delay, 10) || 3;
          setTimeout(() => this.show(), seconds * 1000);
        } else if (trigger === 'exit_intent') {
          const handler = (e) => {
            if (!e.relatedTarget && e.clientY <= 0) {
              this.show();
              document.removeEventListener('mouseout', handler);
            }
          };
          document.addEventListener('mouseout', handler);
          setTimeout(() => this.show(), 20000);
        } else if (trigger === 'scroll') {
          const pct = parseInt(this.dataset.scroll, 10) || 50;
          const scrollHandler = () => {
            const scrolled = (window.scrollY / (document.body.scrollHeight - window.innerHeight)) * 100;
            if (scrolled >= pct) {
              this.show();
              window.removeEventListener('scroll', scrollHandler);
            }
          };
          window.addEventListener('scroll', scrollHandler);
        }
      }

      show() {
        if (this.shown) return;
        this.shown = true;
        this.setAttribute('data-visible', 'true');
        sessionStorage.setItem(this.sessionKey, '1');
      }

      hide() {
        this.removeAttribute('data-visible');
      }

      setupActions() {
        this.querySelectorAll('[data-promo-close]').forEach((el) => {
          el.addEventListener('click', () => this.hide());
        });

        const dismissBtn = this.querySelector('[data-promo-dismiss]');
        if (dismissBtn) {
          dismissBtn.addEventListener('click', () => {
            localStorage.setItem(this.dismissKey, '1');
            this.hide();
          });
        }

        const copyBtn = this.querySelector('[data-promo-copy]');
        if (copyBtn) {
          copyBtn.addEventListener('click', () => {
            const code = copyBtn.dataset.code;
            const label = copyBtn.querySelector('[data-promo-copy-label]');
            const originalText = label.textContent;

            const done = () => {
              label.textContent = 'Copied!';
              setTimeout(() => {
                label.textContent = originalText;
              }, 1500);
            };

            if (navigator.clipboard) {
              navigator.clipboard.writeText(code).then(done).catch(done);
            } else {
              done();
            }
          });
        }
      }
    }

    customElements.define('promotion-popup', PromotionPopup);
  
  } catch(e) { console.error(e); }
})();
})();
